<template>
    <div class="experience_wrap spackage padding-20 bgc box-shadow">
        <div class="top_wrap">
            <div class="title"><span>经验设置</span></div>
            <div class="top_block">
                <span class="label">开启经验</span>
                <el-switch v-model="dataSet.isopenexp" active-text="社区经验已开启"></el-switch>
            </div>
            <div class="top_block">
                <span class="label">每日经验上限</span>
                <el-input v-model="dataSet.maxexpbyday" placeholder="请输入内容"></el-input>
                <span>每日用户在操作获得经验的上限值</span>
            </div>
        </div>
        <div class="bottom_wrap" v-show="dataSet.isopenexp">
            <el-tabs v-model="activeTitleName" class="trendName">
                <el-tab-pane label="社区经验" name="first"></el-tab-pane>
            </el-tabs>
            <el-table :data="tableData" ref="table" @selection-change="handleSelectionChange">
                <el-table-column type="selection" label="开关"  width="55"></el-table-column>
                <el-table-column prop="rebatname" label="名称" align="center"></el-table-column>
                <el-table-column prop="" label="周期" align="center" width="900">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-radio-group v-model="scope.row.periodtype" size="medium">
                                <el-radio-button :label="1">一次性</el-radio-button>
                                <el-radio-button :label="2">小时</el-radio-button>
                                <el-radio-button :label="3">天</el-radio-button>
                                <el-radio-button :label="0">不限</el-radio-button>
                            </el-radio-group>
                            <div class="showDay" v-show="scope.row.periodtype===2 || scope.row.periodtype===3">
                                <span>周期<el-input v-model="scope.row.periodvalue" placeholder="0"></el-input></span>
                                <span>次数<el-input v-model="scope.row.periodtimes" placeholder="0"></el-input></span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="expvalue" label="站点经验" align="center" width="250">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.expvalue" placeholder="0"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="footer">
            <el-button @click="cancle">取消</el-button>
            <el-button type="primary" @click="saveSet">保存</el-button>
        </div>
    </div>
</template>
<script>
    import {getExpData, saveExpData} from '@/api/starMgtApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    import { spawn } from 'child_process'
    export default {
        name: "IntegralSetting",
        data() {
            return {
                activeTitleName: 'first',
                periodtype:1, //周期默认值
                periodvalue:'', //周期值
                periodtimes:'', //周期次数
                expvalue:'0', //站点经验值
                isChangePage:0,
                dataSet:{
                    isopenexp: true,
                    maxexpbyday:'0', //每日经验上限
                },
                tableData:[],
                // tableData: [{
                //     rebatname: '发布帖子',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:1
                // },{
                //     rebatname: '帖子置顶',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:2
                // },{
                //     rebatname: '帖子加精',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:3
                // },{
                //     rebatname: '帖子被点赞',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:4
                // },{
                //     rebatname: '帖子被评论',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:5
                // },{
                //     rebatname: '帖子被删',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:6
                // },{
                //     rebatname: '评论帖子',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:7
                // },{
                //     rebatname: '评论被删',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:8
                // },{
                //     rebatname: '回复帖子',
                //     periodtype:1,
                //     periodvalue:'0',
                //     periodtimes:'0',
                //     expvalue:'0',
                //     rebattype:9
                // }],
                selectVals: [], // 储存选中的row
            }
        },
        components: {
            Loading
        },
        mounted() {
            this.getList()
        },
        // watch: {
        //     dataSet: {
        //         handler(newV, oldV) {
        //             console.log(newV)
        //             console.log(oldV)
        //             if(newV !== oldV){
        //                 this.isChangePage=1
        //             }else{
        //                 this.isChangePage=0
        //             }
        //             console.log(this.isChangePage)
        //             // console.log('改变了数据')
        //             // this.isChangePage=1
        //         },
        //         deep: true,
        //         immediate: true
        //     }
        // },
        methods: {
            selectAll(name){
                this.$nextTick(()=>{
                    this.tableData.forEach(row => {
                        if (row.status === 0) return
                        this.$refs[name].toggleRowSelection(row,true)
                    })
                })
            },
            handleSelectionChange(val){
                this.selectVals = val.map(item=>item.rebattype)
            },
            // 保存经验设置
            saveSet(){
                this.setLoading(true)
                const rebatjson = this.tableData.map((item, index) => {
                    const isSelected=this.selectVals.includes(item.rebattype)
                    return {
                        status: isSelected?1:0, //开关
                        rebatname: item.rebatname, //名称
                        rebattype:item.rebattype, //积分类型
                        periodtype: item.periodtype, //周期类型
                        periodvalue: item.periodvalue, //周期
                        periodtimes: item.periodtimes, //周期次数
                        expvalue: item.expvalue, //经验值
                    }
                })
                let params = {
                    isopenexp: this.dataSet.isopenexp?1:0,
                    maxexpbyday:this.dataSet.maxexpbyday?this.dataSet.maxexpbyday:'',
                    rebatjson: JSON.stringify(rebatjson)
                }
                console.log(params)
                saveExpData({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data)
                        this.setLoading(false)
                        this.$message({type: 'success', message: '保存成功！'})
                        this.getList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 获取列表数据
            getList(){
                this.setLoading(true)
                getExpData({
                    data: Object.assign({}, '', this.page),
                    success: data => {
                        console.log(data)
                        this.setLoading(false)
                        let dataSet=data.data
                        // this.tableData=JSON.parse(dataSet.rebatjson)
                        this.tableData=dataSet.mapList
                        console.log(this.tableData)
                        this.dataSet.isopenexp=dataSet.isopenexp===1?true:false
                        this.dataSet.maxexpbyday=dataSet.maxexpbyday
                        this.selectAll('table')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 取消
            cancle() {
                console.log(this.isChangePage)
                if(this.isChangePage===1){
                    this.$confirm('是否要保存设置？您设置的内容未保存，退出后页面将恢复设置前的状态。', '提示', {
                    confirmButtonText: '保存',
                    cancelButtonText: '退出'
                }).then(() => {
                    this.saveSet()
                    this.$router.go(-1);
                }).catch(() => {
                    this.$router.go(-1);
                })
                }else{
                    this.$router.go(-1);
                }
            },
            ...mapActions([
                'setLoading'
            ]),
        },
    }
</script>
<style lang="scss">
    .padding-20{
        margin-bottom: 30px
    }
    .experience_wrap{
        background: #fff;
        .top_wrap{
            .title {
                padding-left: 8px;
                border-left: solid 2px #409EFF
                span {
                    font-size: 16px;
                    font-weight: bold;
                    color: #303133
                }
            }
            .top_block{
                font-size: 14px;
                margin-top: 20px;
                display: flex;
                align-items: center;
                .label{
                    width: 100px
                }
                .el-input{
                    width: 80px;
                    height: 32px;
                    margin-right: 10px;
                    .el-input__inner{
                        width: 100%;
                        height: 100%
                    }
                }
            }
        }
        .bottom_wrap{
            margin-top: 25px;
            // margin-bottom:60px;
            .showDay{
                display: flex;
                width:520px;
                margin-left:180px;
                span{
                    display: flex;
                    align-items: center;
                    margin-top: 15px;
                    margin-right: 15px;
                    .el-input{
                        width: 134px;
                        height: 36px;
                        margin-left: 10px;
                        .el-input__inner{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
        /*button样式修改*/
        .el-radio-button__inner{
            background: rgba(230,241,252,1);
            width: 130px;
            height: 30px;
            line-height: 30px;
            padding: 0 0 0 0;
        }
    }
    .footer{
        position: fixed;
        width: calc(100% - 180px);
        bottom: 0;
        text-align: center;
        background: #fff;
        padding: 15px 0;
        left: 180px;
        right: 0;
        z-index: 3;
        border-top: solid 1px #eee;
        .el-button{
            padding: 0 0 0 0;
            width: 90px;
            height: 32px;
            line-height: 32px;
        }
    }
    /*周期单选框样式修改*/
    .table-position span{
        margin:0 0;
        color:#333
    }
    .experience_wrap .el-radio-button__inner{
        border-top: 1px solid #82C0FF;
        border-bottom: 1px solid #82C0FF;
    }
   .el-radio-button__inner:last-child{
        border-right: 1px solid #82C0FF;
    }
    .el-radio-button:first-child .el-radio-button__inner{
        border-left: 1px solid #82C0FF;
    }
</style>

